import { z } from 'zod';
import { FEATURE_FLAG } from '~/constants';

import { RouteExportParams } from '~/types/router.type';

import {
  zodCallOffsQueryParamsSchema,
  zodCallOffStatusSchema,
} from '~/data/callOff';

/**
 * Search params schema for the call-off create route.
 * - duplicateCallOffId: Optional, used when duplicating an existing call-off
 */
export const zodCreateCallOffSearchParamsSchema = z.object({
  duplicateCallOffId: z.uuid().optional(),
});

export const zodCallOffsRouteParamsSchema = zodCallOffsQueryParamsSchema
  .omit({
    contractId: true,
    deliveryDateFrom: true,
    deliveryDateUntil: true,
    groupBy: true,
    limit: true,
    offset: true,
    searchString: true,
    sellerId: true,
    status: true,
    view: true,
  })
  .extend({
    contractId: z
      .union([z.uuid(), z.literal('')])
      .optional()
      .default(''),
    deliveryDateFrom: z.iso.date().optional().catch(undefined),
    deliveryDateUntil: z.iso.date().optional().catch(undefined),
    searchString: z.string().trim().optional().default('').catch(''),
    sellerId: z
      .union([z.uuid(), z.literal('')])
      .optional()
      .default(''),
    status: z.array(zodCallOffStatusSchema).optional().default([]).catch([]),
  });

export const routeParams: RouteExportParams = {
  featureFlag: [
    FEATURE_FLAG.MODULE_CALL_OFFS, // company-account feature flag managed in the admin app
    FEATURE_FLAG.MANAGE_CALL_OFFS, // user feature flag managed in the user form
  ],
};
